import { ReactElement } from "react";
import { IContent } from "@kunduz/data-access-cms-api";
import { DesktopNavMenu, blue, green } from "@kunduz/ui-components";
import { prepareCmsMenuItems } from "./cmsMenuItems";
import { trackEventNext } from "@kunduz/utility-analytics";

export const DesktopLeft = (props: {
  headerType: "student" | "teacher" | "school";
  desktopLeftCmsData?: IContent.HeaderItemsResponse["components"];
}): ReactElement => {
  const iconColors = {
    student: blue[600],
    teacher: green[600],
    school: blue[600],
  };
  function handleButtonClicked(label?: string) {
    trackEventNext({ event: "Navbar Button Clicked", label });
  }

  return (
    <DesktopNavMenu
      menus={prepareCmsMenuItems(
        iconColors[props.headerType],
        props.desktopLeftCmsData,
        handleButtonClicked,
      )}
    />
  );
};
